import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import PlatformInfoLinks from '../components/PlatformInfoLinks';

export default function PlatformInfoLinksContainer() {
  const navRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  function handleFocusIn(e) {
    if (
      (e.relatedTarget instanceof window.HTMLElement &&
        navRef.current.contains(e.relatedTarget)) ||
      e.type === 'click'
    ) {
      setIsExpanded(true);
    }
  }

  function handleFocusOut(e) {
    if (!navRef.current) return;

    if (
      !e.relatedTarget ||
      !(e.relatedTarget instanceof window.HTMLElement) ||
      !navRef.current.contains(e.relatedTarget)
    ) {
      setIsExpanded(false);
    }
  }

  useEffect(() => {
    if (!navRef.current) return null;

    navRef.current.addEventListener('focusin', handleFocusIn);
    navRef.current.addEventListener('focusout', handleFocusOut);

    return () => {
      navRef.current.removeEventListener('focusin', handleFocusIn);
      navRef.current.removeEventListener('focusout', handleFocusOut);
    };
  }, []);

  return (
    <nav
      ref={navRef}
      className="PlatformInfoLinksContainer relative dib"
      onMouseEnter={handleFocusIn}
      onMouseLeave={handleFocusOut}
    >
      <button
        type="button"
        className="font-16 lg:font-18 secondary pointer transition nowrap"
        aria-haspopup="true"
        aria-expanded={isExpanded}
        onClick={handleFocusIn}
        onMouseEnter={handleFocusIn}
      >
        Why Good Dog
      </button>
      <div
        className={classnames('absolute top-0 left-0 mt6 pt4 z-max', {
          'pointer-events-none': !isExpanded
        })}
      >
        <div
          role="menu"
          className={classnames(
            'font-16 secondary fw-medium bg-white w-max-content transition dropdown-box-shadow br12 pv2 ph2 z-999',
            isExpanded ? 'o-100' : 'o-0'
          )}
          style={{
            transform: isExpanded ? 'translateY(0)' : 'translateY(-10px)'
          }}
        >
          <PlatformInfoLinks />
        </div>
      </div>
    </nav>
  );
}
